import { createContext } from 'react';

const BRAND = process.env.NEXT_PUBLIC_CHANNEL_NAME || process.env.CHANNEL_NAME;

const Context = createContext(BRAND || '');

export const BrandProvider = Context.Provider;
